import { API_URL } from "apiConfig";

/**
 * Which front end an event came from. Both apps post to the same server, and
 * nearly every question ("how many visitors?", "which pages?") is asked about
 * one site or the other, never the pair.
 */
export const SITE = "marketplace";

export const TRACK_ENDPOINT = new URL("/track", API_URL).toString();

// One runaway render loop should cost a handful of rows, not a table.
export const MAX_ERRORS_PER_PAGE = 10;
